import React from 'react';

const NewsFlash = () => {
  const announcements = [
    {
      title: 'Nursery Admission 2026-27 Open',
      link: 'https://www.bvmtrmn.edu.in/nursery-admission.php',
      label: 'Click here for Details'
    },
    {
      title: 'Admission Std. XI (Science & Commerce)',
      link: 'https://entab.online/BVMTRM',
      label: 'Register Now'
    },
    {
      title: 'Recruitment Notice 2026-27',
      link: 'https://www.bvmtrmn.edu.in/pdf/RECRUITMENT%20NOTICE%202026-27.pdf',
      label: 'View Notice'
    }
  ];

  return (
    <div className="news-flash-wrapper">

      <div className="flash-badge">
        <i className="bi bi-megaphone-fill"></i> NOTICATION
      </div>

      <div className="flash-marquee-container">

        <div className="flash-marquee-content">

          {[...announcements, ...announcements].map((item, index) => (

            <span className="flash-item" key={index}>

              <i className="bi bi-bell-fill text-warning"></i>

              {item.title}

              <a href={item.link} target="_blank" rel="noreferrer">
                {item.label}
              </a>

            </span>

          ))}

        </div>

      </div>

    </div>
  );
};

export default NewsFlash;